import { render, staticRenderFns } from "./cipherDataOnchain.vue?vue&type=template&id=b2a6e138&scoped=true&"
import script from "./cipherDataOnchain.vue?vue&type=script&lang=js&"
export * from "./cipherDataOnchain.vue?vue&type=script&lang=js&"
import style0 from "./cipherDataOnchain.vue?vue&type=style&index=0&id=b2a6e138&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a6e138",
  null
  
)

export default component.exports